import { Container } from "react-bootstrap";
import "./Home.css";
import heroImg from "../../imgs/hero-image.png";
import RoundedImg from "../RoundedImg";
const Home = () => {
  const gap = {
    rowGap: "40px",
  };

  return (
    <>
      <section className="container-holder">
        <Container>
          <div
            className="row align-items-center pt-5 justify-content"
            style={gap}
          >
            <div className="col-lg-6">
              <h1 className="pb-5 mb-5 discover">
                Discover
                <br />
                Most
                <br />
                Suitable
                <br />
                Property
                <br />
              </h1>
              <p className="text-white-50 lh-1">
                Find a variety of properties that suit you evey easilty
                <br />
                Forget all difficulties in finding a residence for you
              </p>
              <div className="row text-center pt-4 col-10">
                <div className="col-4">
                  <h2>
                    9,000 <span className="text-warning">+</span>
                  </h2>
                  <p className="text-white-50">Premuim Proudct</p>
                </div>
                <div className="col-4">
                  <h2>
                    2,000 <span className="text-warning">+</span>
                  </h2>
                  <p className="text-white-50">Happy Customer</p>
                </div>
                <div className="col-4">
                  <h2>
                    28 <span className="text-warning">+</span>
                  </h2>
                  <p className="text-white-50">Awards Winning</p>
                </div>
              </div>
            </div>
            <RoundedImg img={heroImg} />
          </div>
        </Container>
      </section>
    </>
  );
};

export default Home;
